import type {Commit} from '../../types/shared'
import {ListView} from '@github-ui/list-view'
import {CommitRow} from './CommitRow'
import {useCurrentRepository} from '@github-ui/current-repository'
import {useFilters} from '../../contexts/FilterContext'
import {Panel} from '../Panel'
import {useId} from 'react'
import {TimelineRow} from './TimelineRow'
import {useShouldClipTimeline} from './FileHistory'

export type CommitGroupProps = {
  commits: Commit[]
  title: string
  isFirstGroup: boolean
}

/**
 * See ListView stories for a representation of this component.
 * ui/packages/list-view/src/stories/Commits.stories.tsx
 * https://ui.githubapp.com/storybook/?path=/story/recipes-listview-dotcom-pages--commits
 */
export function CommitGroup({commits, title, isFirstGroup}: CommitGroupProps) {
  const repo = useCurrentRepository()
  const filters = useFilters()
  const groupId = useId()
  const shouldClipTimeline = useShouldClipTimeline(isFirstGroup)

  return (
    <>
      <TimelineRow clipTimeline={shouldClipTimeline ? 'top' : 'none'}>
        <TimelineRow.Heading as="h3" id={groupId} title={`Commits on ${title}`} data-testid="commit-group-title" />
      </TimelineRow>
      <Panel>
        <ListView key={title} title={title} titleHeaderTag="h3" ariaLabelledBy={groupId}>
          {commits.map(commit => {
            return <CommitRow key={commit.oid} commit={commit} repo={repo} path={filters.currentBlobPath} />
          })}
        </ListView>
      </Panel>
    </>
  )
}

try{ CommitGroup.displayName ||= 'CommitGroup' } catch {}